import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IApiResponse, IFetchAlerts, ISingleAlertApiResponse } from "@/services/alert/alerts.type";

export interface AlertState {
  alert: IApiResponse;
  listLoading: boolean;
  singleLoading: boolean;
  // Changed to 'any' to support both boolean (old) and object (new) error data
  error: any; 
  alertById: ISingleAlertApiResponse;
}

export const initialState: AlertState = {
  alert: {
    data: [],
    pagination: {
      totalRecords: 0,
      currentPage: 0,
      totalPages: 0,
      nextPage: 0,
      previousPage: 0,
    },
    success: false,
    message: "",
  },
  listLoading: false,
  singleLoading: false,
  error: false,
  alertById: {
    success: false,
    message: '',
    data: {} as any 
  }
};

const alertSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    getAlerts: (state, action: PayloadAction<IFetchAlerts>) => {
      state.listLoading = true;
      state.error = false;
    },
    getAlertsSuccess: (state, action: PayloadAction<IApiResponse>) => {
      state.listLoading = false;
      state.alert = { ...action.payload };
    },
    // Fix: Added action payload to capture the error for the Global Toast
    getAlertsFailure: (state, action: PayloadAction<any>) => {
      state.listLoading = false;
      state.error = action.payload || true; // Fallback to true to keep existing boolean logic safe
      state.alert = { ...initialState?.alert };
    },

    // Single Record Actions
    getAlertById: (state, action: PayloadAction<string>) => {
      state.singleLoading = true;
      state.error = false;
    },
    getAlertByIdSuccess: (state, action: PayloadAction<ISingleAlertApiResponse>) => {
      state.singleLoading = false;
      state.alertById = { ...action.payload };
    },
    // Fix: This resolves the 'void' TS error. 
    // It now accepts the ISingleAlert or AxiosError payload from your Saga.
    getAlertByIdFailure: (state, action: PayloadAction<any>) => {
      state.singleLoading = false;
      state.error = action.payload || true; 
      state.alertById = { ...initialState.alertById };
    },
    
    // Clear state when leaving page
    clearAlertDetail: (state) => {
      state.alertById = { ...initialState.alertById };
      state.error = false;
    }
  },
});

export const { 
  getAlerts, 
  getAlertsSuccess, 
  getAlertsFailure, 
  getAlertById, 
  getAlertByIdSuccess, 
  getAlertByIdFailure,
  clearAlertDetail
} = alertSlice.actions;

export default alertSlice.reducer;